import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { DarkModeProvider } from "./helpers/ThemeContext";
import store from "./store";
import { ChatbotProvider } from "./pages/chatbot/service/useChatbot";
import Chatbot from "./pages/chatbot/Chatbot";
import { NetworkProvider } from "./helpers/NetworkContext";
import { FavNetworkProvider } from "./helpers/FavNetworkContext";
import { loggedInUserService } from "./services/loggedInUser.service";
import { CONSTANTS } from "./constants";
import "../src/locales/i18n/i18n";

// ✅ Move hooks inside a component
const RootApp = () => {
  const [isEMTUser, setIsEMTUser] = useState(false);

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe(
      (data: any) => {
        const isEmtUser = checkIsEMTUser(data?.userData);
        setIsEMTUser(isEmtUser);
      }
    );
    return () => subscription.unsubscribe();
  }, []);

  const checkIsEMTUser = (loggedInUser: any): boolean => {
    if (loggedInUser?.roles) {
      return loggedInUser.roles.some(
        (item: any) => item.name === CONSTANTS.ROLES.EMT
      );
    }
    return false;
  };

  return (
    <Provider store={store}>
     
        <DarkModeProvider>
          <NetworkProvider>
            <FavNetworkProvider>
              {!isEMTUser ? (
                <ChatbotProvider>
                  <App />
                  <Chatbot />
                </ChatbotProvider>
              ) : (
                <App />
              )}
            </FavNetworkProvider>
          </NetworkProvider>
        </DarkModeProvider>
   
    </Provider>
  );
};

ReactDOM.render(<RootApp />, document.getElementById("root"));

defineCustomElements(window);